import React, { useCallback, useEffect, useState } from "react"
import DownArrow from "../../../assets/icons/DownArrow"
import styles from "./index.module.scss"

const DisclosureContext = React.createContext(null)

function DisclosureProvider({ children, defaultExpanded = false, onExpand = () => {} }) {
  const [bIsExpanded, setIsExpanded] = useState(defaultExpanded)

  useEffect(() => {
    onExpand(bIsExpanded)
  }, [bIsExpanded])

  return (
    <DisclosureContext.Provider value={{ defaultExpanded, bIsExpanded, setIsExpanded }}>
      {children}
    </DisclosureContext.Provider>
  )
}

function useDisclosure() {
  return React.useContext(DisclosureContext)
}

function Disclosure({
  children,
  defaultExpanded = false,
  onExpand,
  className,
  ...props
}) {
  return (
    <DisclosureProvider defaultExpanded={defaultExpanded} onExpand={onExpand}>
      <div className={`${styles.disclosureContainer} ${className || ""}`} {...props}>
        {children}
      </div>
    </DisclosureProvider>
  )
}

function DisclosureHeader({
  children,
  cArrowPosition = "left",
  className,
  titleClassName,
  ...props
}) {
  const { bIsExpanded, setIsExpanded } = useDisclosure()

  const { onClick } = props
  delete props.onClick

  const handleExpand = useCallback(() => {
    const bPreventExpansion = onClick ? !onClick() : false
    if (bPreventExpansion) return
    setIsExpanded((bWasExpanded) => !bWasExpanded)
  }, [onClick])

  const bArrowLeft = cArrowPosition === "left"
  const bArrowRight = cArrowPosition === "right"

  return (
    <div
      className={`${styles.disclosureHeader} ${className || ""}`}
      onClick={handleExpand}
      {...props}
    >
      {bArrowLeft && (
        <div className={styles.disclosureIconLeft}>
          <DownArrow
            fill="#000"
            style={{
              transform: bIsExpanded && "rotate(-180deg)",
              transition: "all .2s",
            }}
          />
        </div>
      )}
      <div className={`${styles.disclosureTitle} ${titleClassName || ""}`}>
        {children}
      </div>
      {bArrowRight && (
        <div className={styles.disclosureIconRight}>
          <DownArrow
            fill="#000"
            style={{
              transform: bIsExpanded && "rotate(-180deg)",
              transition: "all .2s",
            }}
          />
        </div>
      )}
    </div>
  )
}

function DisclosureContent({ children, className, classNameExpanded, ...props }) {
  const { bIsExpanded } = useDisclosure()

  return (
    <div
      className={`${styles.disclosureContent} ${
        (bIsExpanded && styles.expanded) || ""
      } ${className} ${(bIsExpanded && classNameExpanded) || ""}`}
      {...props}
    >
      {children}
    </div>
  )
}

Disclosure.Header = DisclosureHeader
Disclosure.Content = DisclosureContent

export { useDisclosure, Disclosure, DisclosureHeader, DisclosureContent }

export default Disclosure
